<template>
  <v-dialog
    v-model="mutableIsVisible"
    scrollable
    :persistent="true"
    :width="1126"
    :noClickAnimation="true"
    @click:outside="hide"
  >
    <form>
      <v-card>
        <v-card-title>
          {{ title }}
        </v-card-title>
        <v-divider />
        <v-card-text class="py-4">
          <VTreeview
            v-model="node"
            :items="items"
            :itemKey="itemKey"
          />
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            @click="hide"
          >
            {{ $t('forms.btn.cancel') }}
          </v-btn>
          <v-btn
            color="primary"
            type="submit"
            @click.prevent="confirm"
          >
            {{ $t(`forms.labels.confirm`) }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </form>
  </v-dialog>
</template>

<script>
import VTreeview from '@/components/shared/widgets/forms/VuetifyInputs/VTreeview.vue';

export default {
    components: {
        VTreeview,
    },
    props: {
        isVisible: {
            type: Boolean,
            default: false,
        },
        items: {
            type: Array,
            default: () => [],
        },
        itemKey: {
            type: String,
            default: 'id',
        },
        title: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            mutableIsVisible: null,
            node: [],
            isFormDirty: false,
        };
    },
    watch: {
        isVisible: {
            handler() {
                this.mutableIsVisible = this.isVisible;
            },
            immediate: true,
        },
    },
    methods: {
        hide() {
            this.mutableIsVisible = false;
            this.$emit('hide', this.mutableIsVisible);
        },
        confirm() {
            this.$emit('confirm', this.node);
        },
    },
};
</script>
